import React, { useEffect, useState } from "react";
import { url } from "../constants/url";
import {
  CircularProgress,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const LeadRemarks = ({ leadId }) => {
  const [remarks, setRemarks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRemarks = async () => {
      try {
        const res = await fetch(
          `${url}/api/leads/fetch-lead-remarks/${leadId}`
        );
        const data = await res.json();
        // Filter out empty remarks
        setRemarks(
          (data.remarks || []).filter(
            (r) => r.remarks && r.remarks.trim() !== ""
          )
        );
      } catch (error) {
        setRemarks([]);
      }
      setLoading(false);
    };
    fetchRemarks();
  }, [leadId]);

  if (loading) return <CircularProgress />;
  if (!remarks.length) return <Typography>No remarks found.</Typography>;

  return (
    <List>
      {remarks.map((remark, idx) => (
        <ListItem key={idx} alignItems="flex-start">
          <ListItemText
            primary={remark.remarks}
            secondary={
              <Typography
                component="span"
                variant="caption"
                color="text.secondary"
              >
                {remark.date ? new Date(remark.date).toLocaleString() : ""}
              </Typography>
            }
          />
        </ListItem>
      ))}
    </List>
  );
};

export default LeadRemarks;
